import { Injectable } from '@angular/core';
import { Observable, fromEvent } from 'rxjs';
import { distinctUntilChanged, map, shareReplay, startWith } from 'rxjs/operators';

export enum BreakpointSizeEnum {
  Small = 0,
  Medium = 768,
  Large = 992,
  ExtraLarge = 1200,
  ExtraExtraLarge = 1400,
}

export enum ScreenSizeBreakpointNamesEnum {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  ExtraLarge = 'extraLarge',
  ExtraExtraLarge = 'extraExtraLarge',
}
const QUERY = new Map<ScreenSizeBreakpointNamesEnum, BreakpointSizeEnum>([
  [ScreenSizeBreakpointNamesEnum.ExtraExtraLarge, BreakpointSizeEnum.ExtraExtraLarge],
  [ScreenSizeBreakpointNamesEnum.ExtraLarge, BreakpointSizeEnum.ExtraLarge],
  [ScreenSizeBreakpointNamesEnum.Large, BreakpointSizeEnum.Large],
  [ScreenSizeBreakpointNamesEnum.Medium, BreakpointSizeEnum.Medium],
  [ScreenSizeBreakpointNamesEnum.Small, BreakpointSizeEnum.Small],
]);

@Injectable({ providedIn: 'root' })
export class ScreenSizeBreakpointObserverService {
  private readonly _screenSizeBreakpointName$: Observable<ScreenSizeBreakpointNamesEnum>;

  constructor() {
    this._screenSizeBreakpointName$ = fromEvent(window, 'resize').pipe(
      startWith(this._getScreenSize()),
      map(() => {
        return this._getScreenSize();
      }),
      distinctUntilChanged(),
      shareReplay(1),
    );
  }

  public get screenSizeBreakpointName$(): Observable<ScreenSizeBreakpointNamesEnum> {
    return this._screenSizeBreakpointName$;
  }

  private _getScreenSize(): ScreenSizeBreakpointNamesEnum {
    const [[newSize]] = Array.from(QUERY.entries()).filter(([, width]) => window.innerWidth >= width);
    return newSize;
  }
}
